import Button from "../../Components/Button/Button";
import css from "./ReportModal.module.css";
import { useState, useEffect } from "react";
import AddButton from "../../Components/Form/AddButton/AddButton";
import logTemplate from "./logTemplate";
import ReportLog from "./ReportLog";
import { Post } from "../../Services/Server";
import Url from "../../Services/Url";
import User from "../../Services/User";
import DateTime from "../../Components/Form/DateTime/DateTime";

const Report2 = ({ onNext, onBack, children }) => {
    const [started, setStarted] = useState(children.startedByEngineer || null);
    const [finished, setFinished] = useState(children.finishedByEngineer || null);
    
    useEffect(() => {
        setStarted(children.startedByEngineer || null);
        setFinished(children.finishedByEngineer || null);
    }, [children.startedByEngineer, children.finishedByEngineer]);

    const [btn, setBtn] = useState({ text: "Next", onClick: onNext });
    const [saving, setSaving] = useState(false);
    const { logs } = children;

    const clone = () => {
        return JSON.parse(JSON.stringify(logTemplate));
    };

    const handleNext = () => {
        if (btn.text === "Next") onNext();
        else save();
    };

    const initLog = () => {
        if (!children.logs) return [clone()];
        if (!children.logs.length) return [clone()];

        const logList = children.logs.map((log) => {
            const cl = clone();
            cl.id = log.id;
            cl.observation.value = log.observation;
            cl.start.value = log.start;
            cl.finish.value = log.finish;
            cl.images = log.images;
            cl.jobDoneList = log.jobDoneList.reduce(
                (a, v) => [
                    ...a,
                    { label: "Task Done", name: "details", id: v.id, value: v.details },
                ],
                []
            );
            return cl;
        });
        return logList;
    };

    const [logList, setLogs] = useState([...initLog()]);
    
    useEffect(() => {
        setLogs([...initLog()]);
    }, [logs]);

    const addLog = () => {
        setLogs([...logList, clone()]);
    };

    const handleLogChange = (index, field, value) => {
        const updatedLogs = [...logList];
        if (field === "start" || field === "finish") {
            updatedLogs[index][field].value = value;
        }
        setLogs(updatedLogs);
        onChange();
    };

    const normalizeDate = (d) => {
        if (!d) return null;
        if (typeof d === "string" && !isNaN(Date.parse(d))) {
            if (d.includes('T')) {
                return d;
            }
            return new Date(d).toISOString();
        }
        if (typeof d === "object" && d.value) {
            const val = d.value;
            if (typeof val === "string" && val.includes('T') && !isNaN(Date.parse(val))) {
                return val;
            }
            if (val instanceof Date) return val.toISOString();
            if (typeof val === "string" && !isNaN(Date.parse(val))) {
                return new Date(val).toISOString();
            }
        }
        if (d instanceof Date) return d.toISOString();
        try {
            return new Date(d).toISOString();
        } catch (e) {
            console.warn("Invalid date passed to normalizeDate:", d);
            return null;
        }
    };

    const save = async () => {
        setSaving(true);
        setBtn({ text: "Saving...", onClick: null });

        const startedByEngineer = normalizeDate(started);
        const finishedByEngineer = normalizeDate(finished);

        const data = logList.map((log) => ({
            start: normalizeDate(log.start),
            finish: normalizeDate(log.finish),
            observation: log.observation.value,
            jobDoneList: log.jobDoneList.map((job) => ({
                details: job.value,
                id: job.id,
            })),
            images: log.images,
            createdBy: { id: User.getBiodata().id },
            inReport: true,
            id: log.id,
        }));

        children.logs = data;
        children.startedByEngineer = startedByEngineer;
        children.finishedByEngineer = finishedByEngineer;

        // console.log("Saving payload:", children);

        Post(Url.saveReport, children)
            .then((resp) => {
                setLogs([
                    ...logList.map((log, index) => {
                        log.jobDoneList.map((jd, key) => {
                            jd.id = resp.logs[index].jobDoneList[key].id;
                            return jd;
                        });
                        log.id = resp.logs[index].id;
                        return log;
                    }),
                ]);
            })
            .finally(() => {
                window.setTimeout(() => {
                    setBtn({ text: "Next", onClick: onNext });
                    setSaving(false);
                }, 100);
            });
    };

    const onChange = () => {
        if (!saving) setBtn({ text: "Save", onClick: save });
    };

    const onDelete = (index) => {
        const logs = [...logList];
        logs.splice(index, 1);
        setLogs(logs);
    };

    return (
        <div className={css.Report}>
            <div className={css.Head}>
                <h2>Job</h2>
            </div>
            <div className={css.ReportBody}>
                <div>
                    <DateTime onChange={setStarted}>
                        {{
                            label: "Job Started On",
                            name: "startedByEngineer",
                            type: "datetime",
                            value: started,
                        }}
                    </DateTime>
                    <DateTime onChange={setFinished}>
                        {{
                            label: "Job Finished On",
                            name: "finishedByEngineer",
                            type: "datetime",
                            value: finished,
                        }}
                    </DateTime>
                </div>
                <div className={css.LogsCont}>
                    <div className={css.Logs}>
                        {logList &&
                            logList.map((log, index) => (
                                <ReportLog
                                    onChange={(field, value) => handleLogChange(index, field, value)}
                                    onDelete={onDelete}
                                    key={index}
                                    index={index}
                                >
                                    {log}
                                </ReportLog>
                            ))}
                    </div>
                    <AddButton onClick={addLog}>Add Log</AddButton>
                </div>
            </div>
            <div className={css.Foot}>
                <div className={css.Buttons}>
                    <Button className="Btn-Mid" onClick={onBack}>
                        Back
                    </Button>
                    <Button className="Btn-Mid Active" onClick={handleNext}>
                        {btn.text}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Report2;
